import { render, staticRenderFns } from "./napa-altrom.vue?vue&type=template&id=42eb3740&scoped=true"
import script from "./napa-altrom.vue?vue&type=script&lang=js"
export * from "./napa-altrom.vue?vue&type=script&lang=js"
import style0 from "./napa-altrom.vue?vue&type=style&index=0&id=42eb3740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eb3740",
  null
  
)

export default component.exports